import React, { FunctionComponent, useEffect, useState } from 'react';

import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

import { URL } from 'core/util/Regex';

import 'common/link-metadata/LinkMetadata.scss';

interface Props {
    tenantId: number;
    text: string;
}

interface Metadata {
    id: number;
    url: string;
    extractedUrl: string;
    title: string;
    extractorSource: string;
    description: string;
    createdDate: string;
    agencyID: number;
    tenantID: number;
    videos: Array<any>;
    images: Array<any>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Args {
    extractorSource: string;
}

enum ExtractorSource {
    Embedly = 'Embedly',
    Facebook = 'Facebook',
}

export const extractLinksMetadata = async (tenantId: number, links: Array<any>): Promise<any> => {
    return Axios.post(`/api/tenants/${tenantId}/link-metadata/extract`, links);
};

export const extractUrls = (text: string): Array<string> | null => {
    const regexp = URL;

    return (text ?? '').match(regexp);
};

export const LinkMetadata: FunctionComponent<Props> = ({ tenantId, text }) => {
    const [metaDatas, setMetadatas] = useState<Array<Metadata> | null>(null);

    useEffect(() => {
        const urls = extractUrls(text);

        if (urls && urls.length > 0) {
            const reqData = urls.map((data) => {
                return {
                    link: { url: data },
                    extractorSource: ExtractorSource.Embedly,
                };
            });

            try {
                (async (): Promise<void> => {
                    const { data } = await trackPromise(extractLinksMetadata(tenantId, reqData), 'link-metadata');

                    setMetadatas(data);
                })();
            } catch {}
        }
    }, [tenantId, text]);
    return (
        <>
            {metaDatas
                ? metaDatas.map((metadata, index) => (
                      <a
                          className="r4e-link-metadata"
                          href={metadata.extractedUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          key={metadata.extractedUrl}
                      >
                          <div>
                              {metadata?.images?.[0]?.url && (
                                  <div
                                      className="thumbnail"
                                      style={{ backgroundImage: `url(${metadata?.images?.[0]?.url})` }}
                                  />
                              )}
                              <div className="metadata-details">
                                  <div className="description">{metadata.description}</div>
                                  <a
                                      className="extracted-url"
                                      href={metadata.extractedUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                  >
                                      {metadata.extractedUrl}
                                  </a>
                              </div>
                          </div>
                      </a>
                  ))
                : ''}
        </>
    );
};
